import {Component, OnInit} from '@angular/core';
import {AdminService} from "../../../../../services/admin.service";
import {SpecializationsService} from "../../services/specializations.service";
import {Router} from '@angular/router';
import {HttpStatus, ValidationRules, Language, FileType, LevelNumber, FileIndex, ModalResult, VALIDATION_PATTERN, ROUTES, ARRAY_INDEX, EXTRA_SPACES_PATTERN} from '../../constants/specializations.constants';
import {
  AnswerModel,
  QuestionSpecializationModel,
  SpecializationModel,
  BeginnerLevelModel,
  AdvancedLevelModel,
  PositionModel
} from "../../models/learning.model";
import {UserService} from "../../../../../services/user.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SpecWarningComponent} from "../spec-warning/spec-warning.component";

@Component({
  selector: 'app-edit-specialization',
  templateUrl: './edit-specialization.component.html',
  styleUrls: ['./edit-specialization.component.css']
})
export class EditSpecializationComponent implements OnInit {

  isLoaded = false;
  isEditBtnDisabled = true;
  operationSuccess = false;
  operationFail = false;
  activeTab = 'tab1';
  equalAnswers = false;
  emptyQuestion = false;

  id = this.specializationsServ.nodeId;

  specialization: SpecializationModel;
  position = PositionModel;

  level_1: BeginnerLevelModel;
  level_2: BeginnerLevelModel;
  level_3: AdvancedLevelModel;
  level_4: AdvancedLevelModel;
  level_5: AdvancedLevelModel;

  formData: FormData = new FormData();
  formData2: FormData = new FormData();
  formDataToSend: FormData = new FormData();
  init = true;
  selectGroupId;

  constructor(private adminService: AdminService,
              public specializationsServ: SpecializationsService,
              private userService: UserService,
              private router: Router,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.specialization = new SpecializationModel(null, null, null, true, true, [], []);
    this.getPositions();
    this.loadSpecialization();
    this.validateNodeName();
  }

  private loadSpecialization() {
    this.specializationsServ.getSingleSpec().subscribe(
      (res: any) => this.handleLoadSuccess(res),
      () => {}
    );
  }

  private handleLoadSuccess(res: any) {
    this.specialization = res.body;
    this.selectGroupId = this.specialization.mainGroup.id;
    delete this.specialization['mainGroup'];
    this.assignLevels();
    this.linkRightAnswers();
    this.selectPosition(this.specialization.position);
    this.checkSpecName(this.specialization.name);
    this.isLoaded = true;
  }

  private linkRightAnswers() {
    this.linkQuestionsRightAnswers(this.level_1.ruQuestions);
    this.linkQuestionsRightAnswers(this.level_2.ruQuestions);
  }

  private linkQuestionsRightAnswers(questions: QuestionSpecializationModel[]) {
    questions.forEach(q => {
      const rightAnswerText = q.rightAnswer.answerText;
      const foundAnswer = q.answers.find(a => a.answerText === rightAnswerText);
      if (foundAnswer) {
        q.rightAnswer = foundAnswer;
      }
    });
  }

  private assignLevels() {
    this.level_1 = this.specialization.beginnerLevels[ARRAY_INDEX.FIRST];
    this.level_2 = this.specialization.beginnerLevels[ARRAY_INDEX.SECOND];
    if (this.specialization.advancedLevels[ARRAY_INDEX.FIRST]) this.level_3 = this.specialization.advancedLevels[ARRAY_INDEX.FIRST];
    if (this.specialization.advancedLevels[ARRAY_INDEX.SECOND]) this.level_4 = this.specialization.advancedLevels[ARRAY_INDEX.SECOND];
    if (this.specialization.advancedLevels[ARRAY_INDEX.THIRD]) this.level_5 = this.specialization.advancedLevels[ARRAY_INDEX.THIRD];
  }

  private validateNodeName() {
    if (this.specializationsServ.nodeName === '') {
      this.router.navigateByUrl(ROUTES.SPECIALIZATIONS_LIST);
    }
  }

  closeAlert() {
    this.operationSuccess = false;
    this.operationFail = false;
    this.equalAnswers = false;
    this.emptyQuestion = false;
  }

  get isEditDisabled(): boolean {
    return !this.init || this.isEditBtnDisabled ||
      (this.level_3 && this.level_3.ruRequirements && this.level_3.ruRequirements.length < ValidationRules.MIN_REQUIREMENTS_LENGTH) ||
      (this.level_4 && this.level_4.ruRequirements && this.level_4.ruRequirements.length < ValidationRules.MIN_REQUIREMENTS_LENGTH) ||
      (this.level_5 && this.level_5.ruRequirements && this.level_5.ruRequirements.length < ValidationRules.MIN_REQUIREMENTS_LENGTH);
  }

  checkSpecName(value) {
    this.specialization.name = value;
    const nameInvalid = !value || 
      value.trim() === '' || 
      value.trim().length < ValidationRules.MIN_NAME_LENGTH || 
      value.startsWith(' ') || 
      value.endsWith(' ') || 
      !VALIDATION_PATTERN.test(value);
    
    const questionsInvalid = this.hasInvalidCharacters(this.level_1.ruQuestions) || 
                             this.hasInvalidCharacters(this.level_2.ruQuestions);
    
    this.isEditBtnDisabled = nameInvalid || questionsInvalid;
  }

  preventExtraSpaces(event: KeyboardEvent) {
    const textarea = event.target as HTMLTextAreaElement;
    const currentValue = textarea.value;
    const key = event.key;
  
    if (key === ' ' && currentValue.match(EXTRA_SPACES_PATTERN)) {
      event.preventDefault();
    }
  }

  setActiveLevel(event) {
    this.activeTab = event.nextId;
  }

  getPositions() {
    this.adminService.getActivePositions().subscribe(
      (res: any) => {
        this.specializationsServ.positions = res.body;
        this.selectPosition(this.specializationsServ.positions[0]);
      },
      () => {
      }
    );
  }

  selectPosition(position) {
    this.specializationsServ.selectedPositionId = position.id;
    this.specializationsServ.selectedPositionName = position.name;
    this.specialization.position = position;
  }

  private createQuestionModel() {
    return {
      questionText: "",
      answers: [{answerText: ""}, {answerText: ""}, {answerText: ""}],
      rightAnswer: {answerText: ""}
    };
  }

  addQuestion(level) {
    switch (level) {
      case LevelNumber.LEVEL_1:
        this.level_1.enQuestions.push(this.createQuestionModel());
        this.level_1.ruQuestions.push(this.createQuestionModel());
        break;
      case LevelNumber.LEVEL_2:
        this.level_2.enQuestions.push(this.createQuestionModel());
        this.level_2.ruQuestions.push(this.createQuestionModel());
        break;
    }
  }

  removeQuestion(level) {
    switch (level) {
      case LevelNumber.LEVEL_1:
        this.level_1.enQuestions.splice(ARRAY_INDEX.LAST, 1);
        this.level_1.ruQuestions.splice(ARRAY_INDEX.LAST, 1);
        break;
      case LevelNumber.LEVEL_2:
        this.level_2.enQuestions.splice(ARRAY_INDEX.LAST, 1);
        this.level_2.ruQuestions.splice(ARRAY_INDEX.LAST, 1);
        break;
    }
  }

  setRightAnswer(lvl: number, lang: string, i, k) {
    const level = lvl === LevelNumber.LEVEL_1 ? this.level_1 : this.level_2;
    const questions = lang === Language.RU ? level.ruQuestions : level.enQuestions;
    questions[i].rightAnswer = questions[i].answers[k];
  }

  handleFileInput(type: string, event) {
    const files = event.target.files;
    if (files.length) {
      const file: File = files[0];
      this.formData.set(type, file, file.name);
    } else {
      this.formData.delete(type);
    }
  }

  handleFileInput2(type: string, event) {
    const files = event.target.files;
    if (files.length) {
      const file: File = files[0];
      this.formData2.set(type, file, file.name);
    } else {
      this.formData2.delete(type);
    }
  }

  uploadFile(lvl_id, lvl_number) {
    if (lvl_number === FileIndex.FIRST) {
      this.formDataToSend = this.formData;
    }
    if (lvl_number === FileIndex.SECOND) {
      this.formDataToSend = this.formData2;
    }

    this.adminService.uploadSpecFile(this.formDataToSend, lvl_id).subscribe(
      (res: any) => {
      },
      () => {
        this.specializationsServ.fileUploadFailed = true;
      }
    );
  }

  downloadFile(id) {
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
      }
    );
  }

  add() {
    switch (true) {
      case !this.level_3:
        this.level_3 = new AdvancedLevelModel(null, LevelNumber.LEVEL_3, "", "");
        this.init = false;
        break
      case !this.level_4:
        if(this.level_3.ruRequirements && this.level_3.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH) {
          this.level_4 = new AdvancedLevelModel(null, LevelNumber.LEVEL_4, "", "");
          this.init = false;
        }
        break
      case !this.level_5:
        if(this.level_4.ruRequirements && this.level_4.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH) {
          this.level_5 = new AdvancedLevelModel(null, LevelNumber.LEVEL_5, "", "");
          this.init = false;
        }
        break
      default:
    }
  }

  del() {
    switch (true) {
      case this.level_5 != null:
        delete this.level_5;
        this.init = true;
        break;
      case this.level_4 != null:
        delete this.level_4;
        this.init = true;
        break;
      case this.level_3 != null:
        delete this.level_3;
        this.init = true;
        break;
      default:
        break;
    }
  }

  checkLength(data) {
    if (data.length === 0 || !this.checkRequirementsLength()) {
      this.init = false;
    } else {
      this.init = true;
    }
  }
  
  checkRequirementsLength() {
    if (this.hasAllLevelsValid()) return true;
    if (this.hasTwoLevelsValid()) return true;
    if (this.hasOneLevelValid()) return true;
    return false;
  }

  private hasAllLevelsValid() {
    return this.level_3 && this.level_4 && this.level_5 &&
      this.level_3.ruRequirements && this.level_4.ruRequirements && this.level_5.ruRequirements &&
      this.level_3.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH &&
      this.level_4.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH &&
      this.level_5.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH;
  }

  private hasTwoLevelsValid() {
    return this.level_3 && this.level_4 &&
      this.level_3.ruRequirements && this.level_4.ruRequirements &&
      this.level_3.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH &&
      this.level_4.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH;
  }

  private hasOneLevelValid() {
    return this.level_3 &&
      this.level_3.ruRequirements &&
      this.level_3.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH;
  }

  deleteFile(marker: string) {
    switch (marker) {
      case FileType.RU_PPT1: {
        this.level_1.ruPpt = null;
        break;
      }
      case FileType.EN_PPT1: {
        this.level_1.enPpt = null;
        break;
      }
      case FileType.RU_PPT2: {
        this.level_2.ruPpt = null;
        break;
      }
      case FileType.EN_PPT2: {
        this.level_2.enPpt = null;
        break;
      }
      default: {
        break;
      }
    }
  }

  open() {
    const modalRef = this.modalService.open(SpecWarningComponent);
    modalRef.result.then((result) => {
      if (result === ModalResult.OK) {
        this.editSpecAPI();
      }
    });
  }

  setErrorState(emptyQuestion: boolean, equalAnswers: boolean) {
    this.emptyQuestion = emptyQuestion;
    this.equalAnswers = equalAnswers;
  }

  hasEmptyQuestions(questions: QuestionSpecializationModel[]) {
    return questions.some(q => {
      if (!q.questionText || q.questionText.trim() === '') return true;
      if (!q.rightAnswer.answerText || q.rightAnswer.answerText.trim() === '') return true;
      return q.answers.some(a => !a.answerText || a.answerText.trim() === '');
    });
  }

  hasInvalidCharacters(questions: QuestionSpecializationModel[]) {
    return questions.some(q => {
      if (q.questionText && q.questionText.trim() && !VALIDATION_PATTERN.test(q.questionText)) return true;
      if (q.rightAnswer.answerText && q.rightAnswer.answerText.trim() && !VALIDATION_PATTERN.test(q.rightAnswer.answerText)) return true;
      return q.answers.some(a => a.answerText && a.answerText.trim() && !VALIDATION_PATTERN.test(a.answerText));
    });
  }

  checkQuestionsValidity() {
    const nameInvalid = !this.specialization.name || 
      this.specialization.name.trim() === '' || 
      this.specialization.name.trim().length < ValidationRules.MIN_NAME_LENGTH || 
      this.specialization.name.startsWith(' ') || 
      this.specialization.name.endsWith(' ') || 
      !VALIDATION_PATTERN.test(this.specialization.name);
    
    const questionsInvalid = this.hasInvalidCharacters(this.level_1.ruQuestions) || 
                             this.hasInvalidCharacters(this.level_2.ruQuestions);
    
    this.isEditBtnDisabled = nameInvalid || questionsInvalid;
  }

  checkOnUnique (questions: QuestionSpecializationModel[]) {
    for (const question of questions) {
      const answers = question.answers.map(a => a.answerText.trim()).filter(a => a.length);
      const uniqueAnswers = new Set(answers);
      
      if (answers.length && uniqueAnswers.size < answers.length) {
        return false;
      }
    }
    return true;
  }

  editSpec() {
    if (this.hasEmptyQuestions(this.level_1.ruQuestions) ||
      this.hasEmptyQuestions(this.level_2.ruQuestions)
    ) {
      this.setErrorState(true, false);
      return;
    }

    if (!this.checkOnUnique(this.level_1.ruQuestions) ||
      !this.checkOnUnique(this.level_2.ruQuestions)
    ) {
      this.setErrorState(false, true);
      return;
    }

    this.setErrorState(false, false);

    const level1HasEmptyFields = !this.level_1.ruYoutubeLink || !this.level_1.ruRequirements || (!this.level_1.ruPpt && !this.formData.has('RU_PPT'));
    const level2HasEmptyFields = !this.level_2.ruYoutubeLink || !this.level_2.ruRequirements || (!this.level_2.ruPpt && !this.formData2.has('RU_PPT'));
    const hasEmptyOptionalFields = level1HasEmptyFields || level2HasEmptyFields;

    if (hasEmptyOptionalFields) {
      if (this.specializationsServ.isOperationAccepted === false) {
        this.open();
      } else {
        this.editSpecAPI();
      }

    } else {
      this.editSpecAPI();
    }
  }

  editSpecAPI() {
    this.buildSpecializationLevels();
    this.adminService.updateSpec(this.specialization, this.selectGroupId).subscribe(
      (res: any) => this.handleEditSuccess(res),
      () => this.handleEditError()
    );
  }

  private buildSpecializationLevels() {
    this.specialization.beginnerLevels = [];
    this.specialization.advancedLevels = [];
    this.specialization.beginnerLevels.push(this.level_1, this.level_2);
    if (this.level_3) this.specialization.advancedLevels.push(this.level_3);
    if (this.level_4) this.specialization.advancedLevels.push(this.level_4);
    if (this.level_5) this.specialization.advancedLevels.push(this.level_5);
  }

  private handleEditSuccess(res: any) {
    if (res.status === HttpStatus.OK) {
      this.specializationsServ.updateTree();
      this.operationSuccess = true;
      this.operationFail = false;
      this.uploadFiles();
      this.finishEdit();
    }
  }

  private uploadFiles() {
    this.uploadFile(this.specialization.beginnerLevels[ARRAY_INDEX.FIRST].id, FileIndex.FIRST);
    this.uploadFile(this.specialization.beginnerLevels[ARRAY_INDEX.SECOND].id, FileIndex.SECOND);
  }

  private finishEdit() {
    this.specializationsServ.updateSpecSuccess = true;
    this.router.navigateByUrl(ROUTES.SPECIALIZATIONS_LIST);
  }

  private handleEditError() {
    this.operationFail = true;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/specializations/components/edit-specialization/edit-specialization.component.ts